/* sticky header - browser-controls offset */

(function () {
  'use strict';

  var vv = window.visualViewport;
  if (!vv) return;

  var last = -1;

  function sync() {
    var top = vv.scale > 1.01 ? 0 : vv.offsetTop;
    if (Math.abs(top - last) < 0.5) return;
    last = top;
    document.body.style.setProperty('--yg-visual-viewport-top', top + 'px');
  }

  vv.addEventListener('scroll', sync, { passive: true });
  vv.addEventListener('resize', sync, { passive: true });
  sync();
})();
